import { formatToDay } from "../date-formatter";

export const getDaysBetween = (startDate: Date, endDate: Date): number => {
  const diffTime = Math.abs(startDate.getTime() - endDate.getTime());
  console.log("Diff time", diffTime);
  const timeInDays = diffTime / (1000 * 60 * 60 * 24);
  console.log("Time in days", timeInDays);
  return timeInDays;
};

export const isConsecutiveDates = (startDate: Date, endDate: Date): boolean => {
  const simpleStartDate = formatToDay(startDate);
  const simpleEndDate = formatToDay(endDate);
  const startDay = Number(simpleStartDate.split(".")[0]);
  const endDay = Number(simpleEndDate.split(".")[0]);
  const startMonth = Number(simpleStartDate.split(".")[1]);
  const endMonth = Number(simpleEndDate.split(".")[1]);
  const startYear = Number(simpleStartDate.split(".")[2]);
  const endYear = Number(simpleEndDate.split(".")[2]);

  const daysBetween = Math.abs(startDay - endDay)
  if (daysBetween === 1) {
    return true;
  }

  const monthsBetween = Math.abs(startMonth - endMonth)
  if(daysBetween > 26 && monthsBetween === 1) {
    return true;
  }

  const yearsBetween = Math.abs(startYear - endYear)
  if(daysBetween > 26 && monthsBetween > 10 && yearsBetween === 1) {
    return true;
  }

  return false

}

export const getDaysAgo = (days: number): Date => {
  const date = new Date();
  date.setDate(date.getDate() - days);
  return date;
};
